'use client';

import { Box, Container, IconButton, Typography } from '@mui/material';
import { PageBanner } from '@repo-ui/components/PageBanner';
import { useLocale } from 'next-intl';
import NextImage from 'next/image';

const BANNER_TINT = '#DD7CED';
const BANNER_BACKGROUND = '#121212';

export default function ClassroomFeature() {
  const locale = useLocale();
  return (
    <Box className="ClassroomFeature-root">
      <PageBanner
        title="클래스룸"
        tint={BANNER_TINT}
        contrastColor="#222"
        background={BANNER_BACKGROUND}
        bgImgSrc="/_static/images/page-banner/top_banner5.png"
        breadcrumbProps={{
          tint: '#fff',
          section: '커뮤니티',
          currentTitle: '클래스룸',
        }}
      />
      <Container
        maxWidth="lg"
        sx={{
          display: 'flex',
          flexDirection: 'column',
          height: '100%',
          background: '#fff',
          borderRadius: '30px 30px 0 0',
          overflow: 'hidden',
          my: 8,
        }}
      >
        <Box sx={{ position: 'relative', mx: 'auto' }}>
          <Typography variant="h5" mr={1} sx={{ fontSize: '1.5rem' }}>
            클래스룸이란
          </Typography>

          <IconButton
            onClick={() => {}}
            size="small"
            sx={{
              position: 'absolute',
              top: 0,
              right: -30,
              ':hover': {
                backgroundColor: '#fff8e1',
              },
            }}
          >
            <NextImage
              src="/_static/images/icon_bulb.svg"
              width={22}
              height={22}
              alt=""
              priority={false}
            />
          </IconButton>
        </Box>
      </Container>
    </Box>
  );
}
